import { cmsAxios } from "./config/axiosConfig";

const token = localStorage.getItem("accessToken");

export const getFileById = async (
  fileId: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await cmsAxios.get(`/cms/file/${fileId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "app-api-key": process.env.REACT_APP_CMS_API_KEY,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Error fetching file by ID:", error);
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};
